export interface Tool {
  id: number;
  name: string;
}

export interface Category {
  id: number;
  name: string;
  icon: string;
  tools: Tool[];
}

export const categories: Category[] = [
  {
    id: 1,
    name: "Chatbots",
    icon: "fa-regular fa-comments",
    tools: [
      { id: 1, name: "ChatGPT" },
      { id: 4, name: "Claude" },
      { id: 5, name: "Gemini" }
    ]
  },
  {
    id: 2,
    name: "Image Generation",
    icon: "fa-regular fa-image",
    tools: [
      { id: 2, name: "Midjourney" },
      { id: 6, name: "DALL-E" },
      { id: 7, name: "Stable Diffusion" }
    ]
  },
  {
    id: 3,
    name: "Productivity",
    icon: "fa-regular fa-clock",
    tools: [
      { id: 3, name: "Notion AI" },
      { id: 8, name: "Grammarly" },
      { id: 9, name: "Copy.ai" }
    ]
  }
];